<h2>
  <span class="padding-right-10 color-text-light">
    <i class="fas fa-cookie-bite"></i>
  </span>
  Cookie Preferences
</h2>

<p class="txt-sans-serif margin-top-10 txt-size-base">
  This site uses cookies to personalize content, provide social media features, improve performance, and help determine which features to improve upon or develop next.
</p>

<p class="txt-sans-serif padding-none txt-size-base">
  Check which cookie categories you permit below. You may disallow cookies by deselecting the checkbox, however blocking some types of cookies may impact your experience of the site and the services we are able to offer.
</p>

<form [formGroup]="form"
  (ngSubmit)="onSave()">

  <fieldset>
    <div class="fieldset-control">
      <div class="checkbox-option">
        <input type="checkbox" id="necessary" checked disabled>
        <label for="necessary">Strictly Necessary Cookies</label>
      </div>
      <p class="txt-sans-serif margin-top-10 padding-none txt-size-base color-text-light">
        These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.
      </p>

      <div class="checkbox-option">
        <input type="checkbox"
          id="performance"
          formControlName="performance"
          (change)="onCheckboxChange($event)" >
        <label for="performance">Performance Cookies</label>
      </div>
      <p class="txt-sans-serif margin-top-10 padding-none txt-size-base color-text-light">
        These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site, and will not be able to monitor its performance.
      </p>

      <div class="checkbox-option">
        <input type="checkbox"
          id="targeting"
          formControlName="targeting"
          (change)="onCheckboxChange($event)">
        <label for="targeting">Targeting Cookies</label>
      </div>
      <p class="txt-sans-serif margin-top-10 padding-none txt-size-base color-text-light">
        These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant advertisements on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and device. If you do not allow these cookies, you will experience less targeted advertising.
      </p>
    </div>
  </fieldset>

  <div class="cookie-consent-button-container margin-top-25">
    <button type="submit"
      class="btn-primary"
      [class.is-loading]="isSubmitting"
      [disabled]="isSubmitting">
      Save
      <lcp-loading *ngIf="isSubmitting" iconColor="white"></lcp-loading>
    </button>

    <a (click)="onCancel()"
      class="btn-secondary">
      Cancel
    </a>

    <div class="flex-10a display-none-sm"></div>

    <a *ngIf="anyActiveCookieConsent"
      class="link-tertiary font-size-base" 
      (click)="removeCookieConsent()">
      <i class="far fa-trash-alt"></i>
      Reset
    </a>
  </div>
</form>
